<template>
  <v-container>
    <v-row>
      <HeaderMainForm
        v-model="workflow"
        :show="showActions"
        :isUpdating="isUpdating"
        :integrationTypes="integrationTypes"
        @save="validateItem($event)"
        @close="close"
        @play="tryPlay"
      />
      <v-row class="max-height-row">
        <v-col cols="12" xl="8" lg="7" md="7" sm="12" xs="12" class="scroll-content pr-5">
          <CardAction
            v-model="ownerActions"
            :show="showActions"
            @removeAction="removeAction"
            @editAction="editAction"
            @addSideAction="addSideAction"
            @addEmptyAction="addEmptyAction"
            @addEmptyActionAtPosition="addEmptyActionAtPosition"
            @copyActualAction="copyActualAction"
            @goBack="goBack"
            @selectToMove="selectToMove"
          />
        </v-col>
        <v-col cols="12" xl="4" lg="5" md="5" sm="12" xs="12" class="scroll-content pl-5">
          <WorkFlowMinimap
          :show="showActions"
          v-model="workflow"
          @select="setActiveFlow"
          @redirect-owner="setRedirect('owner', $event)"
          @redirect="setRedirect('', $event)" />
        </v-col>
      </v-row>
    </v-row>
    <v-row>
      <v-dialog v-model="actionDialog" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('workflow.action.title') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <Action
                    v-model="actionToEdit"
                    :dialogVisible="actionDialog"
                    @saveClick="saveCurrentAction"
                    @cancelClick="cancelCurrentAction"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import workflowService from '@/services/WorkflowService'
import WorkFlowMinimap from './WorkFlowMinimap'
import Action from './action'
import CardAction from './components/CardAction'
import HeaderMainForm from './components/HeaderMainForm'

import lodash from 'lodash'

import { mapMutations, mapState } from 'vuex'
import LocalStorageService from '../../services/LocalStorageService'

export default {
  name: 'workflowForm',

  computed: {
    ...mapState(['avaliableActions']),
    actionHeader () { return this.$t('workflow.action.header') }
  },

  props: {
    workflowName: String
  },

  data: () => ({
    ownerActions: {
      cabecalhoActions: '',
      actions: [],
      backAction: null,
      selectedCardToMove: null
    },
    actionToAdd: null,
    actionToEdit: null,
    currentAction: null,
    actionDialog: false,
    isUpdating: false,
    integrationTypes: ['REST', 'JOB'/* , 'SOCKET' */],
    actionNames: [{ actionName: '', actionType: '' }],
    workflow: {
      workflowName: '',
      workflowDescription: '',
      integrationType: '',
      active: true,
      actions: [],
      clientPrefix: '',
      maxFailuresBeforeDeactivation: 50,
      routingkey: 'homolog',
      starterAction: {
        wsAuthorizationType: '',
        wsAuthorizationBean: '',
        wsAuthorizationToken: '',
        credentialName: '',
        cron: '',
        restMethod: ''
      }
    },
    workFlowToSave: {},
    showActions: true
  }),
  watch: {
    '$i18n.locale': {
      handler () { this.ownerActions.cabecalhoActions = this.$t('workflow.action.header') },
      immediate: true
    }
  },
  components: {
    Action,
    HeaderMainForm,
    WorkFlowMinimap,
    CardAction
  },
  created () {
    this.loadDB()
    this.clear()
  },

  methods: {
    selectToMove (index) {
      this.selectedCardToMove = index
      alert(index)
    },

    ...mapMutations(['addAction', 'clear', 'remove']),

    addSideAction (action) {
      action.cabecalhoActions = action.actionName
      action.backAction = this.ownerActions
      if (!action.actions) {
        action.actions = []
      }
      this.showActions = false
      this.ownerActions = action
      setTimeout(() => {
        this.showActions = true
      }, 50)
    },

    editAction (action) {
      this.currentAction = action
      this.actionToEdit = { ...this.currentAction }
      this.showActionDialog()
    },

    showActionDialog () {
      this.actionDialog = true
    },

    saveCurrentAction () {
      Object.keys(this.actionToEdit).forEach((key) => {
        this.currentAction[key] = this.actionToEdit[key]
      })

      this.cancelCurrentAction()
    },

    cancelCurrentAction () {
      if (
        this.actionToAdd !== null &&
        this.actionToAdd.actionName === this.defaultActionName
      ) {
        const index = this.ownerActions.actions.indexOf(this.actionToAdd)
        this.ownerActions.actions.splice(index, 1)
      }
      this.actionToAdd = null
      this.actionDialog = false
    },

    goBack () {
      this.showActions = false
      this.ownerActions = this.ownerActions.backAction
      setTimeout(() => {
        this.showActions = true
      }, 50)
    },

    loadDB () {
      if (this.workflowName) {
        workflowService
          .findByName(this.workflowName)
          .then((response) => {
            this.isUpdating = true
            this.workflow = response.data
            this.workflow.maxFailuresBeforeDeactivation ??= 50
            this.ownerActions.actions = this.workflow.actions
            this.addActionsToStore(this.ownerActions.actions)
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      } else {
        this.ownerActions.actions = this.workflow.actions
      }
    },

    addActionsToStore (actions) {
      if (actions) {
        actions.forEach((action) => {
          workflowService
            .findByActionClassname(action.actionType)
            .then((response) => {
              const payload = {
                name: action.actionName,
                type: response.data.returnType
              }
              this.addAction(payload)
            })
            .finally(() => {
              if (action.actions) {
                this.addActionsToStore(action.actions)
              }
            })
        })
      }
    },

    validateItem (event) {
      if (event.valid) this.saveItem(event.closeOnSave)
    },

    saveItem (closeOnSave) {
      if (this.isUpdating) this.updateItem(closeOnSave)
      else this.createItem(closeOnSave)
    },

    async buildWorkflowToSave () {
      this.workFlowToSave = lodash.cloneDeep(this.workflow)
      const maxFailures = this.workFlowToSave.maxFailuresBeforeDeactivation
      this.workFlowToSave.maxFailuresBeforeDeactivation = maxFailures === 0 ? 500 : maxFailures // TODO: Hotfix. Remover 'maxFailures === 0 ? 500' após atualizar 1.5.2-server
      this.workFlowToSave.starterAction.actionName = 'starterAction'
      this.workFlowToSave.clientPrefix = LocalStorageService.getClientPrefix()
      this.workFlowToSave.lastModifiedBy = LocalStorageService.getUsername()

      /*
      if (this.isUpdating) {
        const responseWS = await workflowService.findByName(this.workflowName)
        this.workFlowToSave.routingkey = responseWS.data.routingkey
      }
      */

      return this.buildWorkflowToSaveObj(this.workFlowToSave)
    },

    buildWorkflowToSaveObj (newAction) {
      delete newAction.backAction

      if (newAction.actions) {
        newAction.actions.forEach((el) => {
          delete el.backAction
          if (newAction === this.workFlowToSave) {
            this.build(newAction.starterAction, el)
          } else {
            if (newAction.alternativeAction !== el) {
              this.build(newAction.alternativeAction, el)
            }
          }

          if (el.actions && el.actions.length > 0) {
            el.alternativeAction = el.actions[0]
            this.buildWorkflowToSaveObj(el)

            delete el.actions
          }
        })
      }

      delete newAction.actions
      return newAction
    },

    build (obj, action) {
      if (obj) {
        if (obj.nextAction) {
          this.build(obj.nextAction, action)
        } else {
          obj.nextAction = action
        }
        delete obj.backAction
      }
    },

    async updateItem (closeOnSave) {
      const wf = await this.buildWorkflowToSave()
      workflowService
        .update(wf)
        .then(() => this.$emit('editItem', closeOnSave, this.workflow))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    async createItem (closeOnSave) {
      const wf = await this.buildWorkflowToSave()
      workflowService
        .create(wf)
        .then(() => {
          this.isUpdating = true
          this.$emit('editItem', closeOnSave, this.workflow)
        })
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    },

    addEmptyAction () {
      this.actionToAdd = {
        actionName: this.defaultActionName
      }
      if (!this.ownerActions.actions) {
        this.ownerActions = {
          ...this.ownerActions,
          ...{ actions: [this.actionToAdd] }
        }
      } else {
        this.ownerActions.actions.push(this.actionToAdd)
      }
      this.editAction(this.actionToAdd)
    },

    addEmptyActionAtPosition (position) {
      this.actionToAdd = {
        actionName: this.defaultActionName
      }
      this.ownerActions.actions.splice(position, 0, this.actionToAdd)
      this.editAction(this.actionToAdd)
    },

    copyActualAction (event) {
      this.actionToAdd = {}

      Object.entries(event.value).forEach(ref => {
        if (ref[0] === 'actionName') {
          this.actionToAdd[ref[0]] = ref[1] + '-copy'
        } else {
          this.actionToAdd[ref[0]] = ref[1]
        }
      })

      this.ownerActions.actions.splice(event.index, 0, this.actionToAdd)
      this.editAction(this.actionToAdd)
    },

    removeAction (index) {
      this.remove(this.ownerActions.actions[index])
      this.ownerActions.actions.splice(index, 1)
    },

    setActiveFlow (action) {
      this.editAction(action)
    },

    setRedirect (level, action) {
      if (level === 'owner') {
        const ownerAction = this.findOwnerAction(action, this.workflow)
        this.addSideAction(ownerAction)
      } else {
        this.addSideAction(action)
      }
    },

    findOwnerAction (action, mainAct) {
      let find = null

      if (mainAct.actions.length === 0) {
        return find
      }

      if (mainAct.actions.findIndex(x => x === action) >= 0) {
        find = mainAct
      }

      if (find === null) {
        mainAct.actions.forEach(act => {
          if (!find && act.actions) find = this.findOwnerAction(action, act)
        })
      }

      return find
    },

    tryPlay (workflow) {
      this.workflowToPlay = workflow
      const bodyContent = '{\n\n}'
      workflowService.play(workflow.workflowName, { bodyContent })
        .then(response => {
          this.$message.success(this.$t('keywords.start_workflow'))
          this.showLog(response.data)
        })
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    showLog (query) {
      const { uniqueId, date, identifier, processType } = query
      this.$versionable.decorators.monitoring.showLog(uniqueId, date, identifier, processType)
    }
  }
}
</script>

<style scoped>
.text-right {
  float: left;
  margin-top: -55px;
  margin-left: 20px;
}

.submit-button {
  text-align: right;
}

.max-height-row {
  max-height: 80vh!important;
}

.scroll-content {
  height: 100%;
  overflow: scroll;
}
</style>
